import axios, {AxiosResponse} from 'axios';
import {IUserGroup, IUserProfile} from '@wholesalechange/chatcomponent';
import {ISiteSettingsDto} from '../auth/interfaces';

export const getUserProfileApi = (): Promise<AxiosResponse<IUserProfile>> => {
  return axios.get<IUserProfile>(`${process.env.REACT_APP_API_URL}/user/profile`);
};
export const updateUserProfileApi = (profile: IUserProfile): Promise<AxiosResponse<IUserProfile>> => {
  return axios.post(
    `${process.env.REACT_APP_API_URL}/user/profile/update`,
    profile
  );
};
export const updateUserProfileNicknameApi = (nickname: string): Promise<AxiosResponse<boolean>> => {
  return axios.post(
    `${process.env.REACT_APP_API_URL}/user/set/nick`,
    {nickname}
  );
};
export const getUserGroupsApi = (): Promise<AxiosResponse<IUserGroup[]>> => {
  return axios.get(
    `${process.env.REACT_APP_API_URL}/user/groups`
  );
};

export const getUserSiteSettingsApi = (): Promise<AxiosResponse<ISiteSettingsDto>> => {
  return axios.get<ISiteSettingsDto>(`${process.env.REACT_APP_API_URL}/user/settings`);
};

export const verifyEmail = (email: string): Promise<AxiosResponse<boolean>> => {
  return axios.get<boolean>(`${process.env.REACT_APP_API_URL}/user/verify/email`,
    {
      params: {
        email
      }
    });
};
// UCSF-3519: the signed-in user's IANA scheduling timezone (null = platform default).
export interface IUserTimezone {
  timezone: string | null;
  written?: boolean;
}

export const getUserTimezoneApi = (): Promise<AxiosResponse<IUserTimezone>> => {
  return axios.get<IUserTimezone>(`${process.env.REACT_APP_API_URL}/user/timezone`);
};

/** Sets the timezone chosen on the profile page; null resets it to "Automatic". */
export const setUserTimezoneApi = (timezone: string | null): Promise<AxiosResponse<IUserTimezone>> => {
  return axios.post(`${process.env.REACT_APP_API_URL}/user/timezone`, {timezone});
};

/** Reports the browser timezone; the server stores it only while the user has none. */
export const detectUserTimezoneApi = (timezone: string): Promise<AxiosResponse<IUserTimezone>> => {
  return axios.post(`${process.env.REACT_APP_API_URL}/user/timezone/detected`, {timezone});
};

export const updateUserVideoAvatarApi = (avatarId: number): Promise<AxiosResponse<IUserProfile>> => {
  return axios.post(
    `${process.env.REACT_APP_API_URL}/user/set/video/avatar`,
    avatarId
  );
};
